import { render, staticRenderFns } from "./PickAnswerContent.vue?vue&type=template&id=da06274e&scoped=true&"
import script from "./PickAnswerContent.vue?vue&type=script&lang=js&"
export * from "./PickAnswerContent.vue?vue&type=script&lang=js&"
import style0 from "./PickAnswerContent.vue?vue&type=style&index=0&id=da06274e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da06274e",
  null
  
)

export default component.exports